import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { AnalyticsService } from '@se-po/shared-data-access-services'
import { SetupBarService } from '@se-po/shared-ui-setup-bar'
import { WhoSubmitter } from './who-submit.service'

@Component({
  selector: 'se-po-household-setup-whos-participating',
  templateUrl: './who.component.html',
  styleUrls: ['./who.component.scss'],
  standalone: false,
})
export class WhoComponent implements OnInit {
  public footerYear = new Date().getFullYear()
  public ready = false
  public title: string
  public subtitle = 'Easily manage schedules, receive important team updates, and stay organized.'
  public childLabel: string
  public meLabel: string
  private app: string
  private page: string
  private label: string

  constructor(
    private analyticsService: AnalyticsService,
    private route: ActivatedRoute,
    public setupBarService: SetupBarService,
    public store: StoreService,
    public submitter: WhoSubmitter,
  ) {
    // no-op
  }

  public ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        if (params.context === 'membership') {
          this.title = 'Who is this membership for?'
          this.childLabel = 'My Child'
          this.meLabel = 'Myself'
        }
        else {
          this.title = 'Who is this account for?'
          this.childLabel = 'Me and my child'
          this.meLabel = 'Just me'
          this.app = 'SingleSignOn'
          this.page = 'HouseholdSetup'
          this.label = 'Who'
          this.analyticsService.pageView(this.app, this.page, this.label)
        }
        if (params.email) {
          this.store.queryStringEmail = params.email
        }
        this.ready = true
        this.setupBarService.percentComplete = 0
      })
  }
}
